module.exports = __webpack_public_path__ + "img/company-team-3.a0378001.jpg";